<template>
  <el-drawer v-model="drawer" title="余额提现" size="30%" :direction="direction" :before-close="handleClose">
    <el-form ref="withdrawalForm" :model="addRow" label-width="100px">
      <div class="money-box">
        <div class="mb-title">提现金额</div>
        <div class="mb-input">
          <div class="mbi-unit">￥</div>
          <div class="mbi-input">
            <input @input="serviceSet" placeholder="请输入提现金额" type="number" class="w300" v-model="addRow.money"></input>
          </div>
        </div>
        <div class="mb-tips">
          <div class="mbt-money">
            <span>账户余额：{{moneyDetail.money}}元</span>
            <span class="mbt-all" @click="allMoney">全部</span>
          </div>
          <div class="mbt-service" v-if="serviceMoney > 0">
            手续费{{serviceMoney.toFixed(2)}}元
          </div>
        </div>
      </div>

      <div class="bank-box">
        <div class="bb-name">
          提现银行卡
        </div>
        <div>
          <el-select class="w300" v-model="addRow.bankId" placeholder="请选择银行卡">
            <el-option :label="item.name+' '+item.bankCode" :key="item.id" :value="item.id" v-for="item in bankList"></el-option>
          </el-select>
        </div>
      </div>
    </el-form>

    <template #footer>
          <span class="dialog-footer">
            <el-button @click="handleClose">关闭</el-button>
            <el-button type="primary" @click="save">提现</el-button>
          </span>
    </template>
  </el-drawer>
</template>

<script>
export default {
  name: "withdrawal-add",
  data() {
    return {
      drawer:false,
      direction:"rtl",
      addRow:{money:"",bankId:""},
      moneyDetail:{money:0},
      bankList:[],
      serviceMoney:0
    }
  },
  mixins: [tableBase],
  methods: {
    openDrawer(){
      this.addRow = {money:"",bankId:""};
      this.drawer = true;
      this.findDetail();
      this.findBankList();
    },
    findDetail(){
      this.simpleGet("/api/mgr/business/shop/money/info/shopMoneyDetail",null,result=>{
        this.moneyDetail = result.data;
      })
    },
    findBankList(){
      this.simpleGet("/api/mgr/business/shop/money/info/shopBank",null,result=>{
        this.bankList = result.data;
      })
    },
    handleClose(){
      this.$emit("success");
      this.drawer = false;
    },
    serviceSet(){
      if($.isNotEmpty(this.addRow.money) && this.addRow.money > 0){
        this.serviceMoney = this.addRow.money * (this.moneyDetail.withdrawRatio/100);
      }else{
        this.addRow.money = "";
      }
    },
    allMoney(){
      this.addRow.money = this.moneyDetail.money;

      this.serviceSet();
    },
    save(){
      let data = this.addRow;
      if($.isEmpty(data.money)){
        this.messageError("请输入提现金额");
        return;
      }else if(data.money > this.moneyDetail.money){
        this.messageError("可用余额不足");
        return;
      }else if(data.money < this.moneyDetail.minWithdrawMoney){
        this.messageError("提现金额不能小于"+this.moneyDetail.minWithdrawMoney);
        return;
      }else if($.isEmpty(data.bankId)){
        this.messageError("请选择提现银行卡");
        return;
      }
      this.simplePost("/api/mgr/business/shop/money/info/incomeSave",this.addRow,result=>{
        this.message("提现成功");
        this.handleClose();
      })
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.money-box{
  padding: 0 10px;
  .mb-title{
    color: #a2a2a2;
  }
  .mb-input{
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    align-items: center;

    .mbi-input{
      input{
        border: none;
        padding: 15px 5px;
      }
      input:focus{
        outline: none;
        border: none;
      }

    }
  }

  .mb-tips{
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;

    .mbt-money{
      .mbt-all{
        margin-left: 10px;
        color: #0071ef;
        cursor: pointer;
      }
    }
  }
}

.bank-box{
  padding: 0 10px;
  display: flex;
  align-items: center;
  height: 40px;

  .bb-name{
    color: #7a7979;
    padding-right: 10px;
  }
}
</style>
